/**
 * @file index.tsx
 *
 * @fileoverview Component to wrap single items in nav.
 */
import React from "react";
import { cva, VariantProps } from "class-variance-authority";
import styles from "./../../sideBlock.module.scss";

export const sideBlockMenuItemWrapper = cva([styles.sideBlockMenuItemWrapper], {
  variants: {
    active: {
      true: styles.sideBlockMenuItemWrapperActive,
    },
  },
});
type SideBlockMenuItemWrapperProps = VariantProps<
  typeof sideBlockMenuItemWrapper
> & {
  children: React.ReactNode;
};
export const SideBlockMenuItemWrapper = ({
  children,
  active,
  ...props
}: SideBlockMenuItemWrapperProps) => {
  return (
    <div className={sideBlockMenuItemWrapper({ active })} {...props}>
      {children}
    </div>
  );
};
